import { Reducer } from "../../lib/redux";
import { VehicleHistoryActions } from "./actions";
import { VehicleHistoryActionTypes, IVehicleHistoryStore } from "./types";

export const defaultVehicleHistory: IVehicleHistoryStore = { currentVehicle: null, previousVehicle: null };

export let vehicleHistory: Reducer<IVehicleHistoryStore, VehicleHistoryActions> = (state = defaultVehicleHistory, action: VehicleHistoryActions): IVehicleHistoryStore => {
    switch (action.type) {
        case VehicleHistoryActionTypes.SET_CURRENTVEHICLE:
            return action.payload.currentVehicle
                ? { ...state, currentVehicle: { id: action.payload.currentVehicle.id }}
                : { ...state, currentVehicle: null };
        case VehicleHistoryActionTypes.SET_PREVIOUSVEHICLE:
            return action.payload.previousVehicle
                ? { ...state, previousVehicle: { id: action.payload.previousVehicle.id }}
                : { ...state, previousVehicle: null };
        case VehicleHistoryActionTypes.CLEAR_CURRENTVEHICLE:
            return { ...state, currentVehicle: null };
        case VehicleHistoryActionTypes.CLEAR_PREVIOUSVEHICLE:
            return { ...state, previousVehicle: null };
        default:
            return state;
    }
};